export var resName = function resName(state) {
  return state.resName;
};